<div class="grid-desktop-container-filter-tree h-100" [class.minimzed-filter]="minimizedFilter">
	<div class="grid-breadcrumbs">
		<div class="pb-3 ps-3">
			<app-breadcrumb [breadcrumbs]="canNavigateToStartingPage ? breadcrumbs : []"> </app-breadcrumb>
		</div>
	</div>
	<div class="grid-filter position-relative">
		<div class="scrollContainer h-100">
			<app-catalog-navigation
				(openNews)="openNews.emit($event)"
				[hasNews]="catalog.featureToggles.simpleFeatureToggles.CatalogNews && catalog.hasNews"
				(emptySearch)="emptySearch.emit()"
				(minimize)="toggleFilterSize()"
				[currentRoutingParams]="currentRoutingParams"
				[catalogSearchResultModel]="catalogSearchResultModel"
				[selectedTags]="selectedTags"
				[defaultTags]="defaultTags"
				[tags]="tags"
				[currentQueryParams]="currentQueryParams"
				[languageCatalogs]="languageCatalogs"
				[relatedCatalogs]="relatedCatalogs"
				[categoryGroups]="categoryGroups"
				[catalogKey]="catalog.key"
				[minimized]="minimizedFilter">
			</app-catalog-navigation>
		</div>
	</div>
	<div class="grid-tree position-relative">
		<div class="position-absolute toggle-details-button zindex-sticky">
			<div
				class="position-fixed cursor-pointer bg-gray-400 rounded d-flex align-items-center justify-content-center toggle-button-size"
				(click)="toggleFilterSize()">
				<div
					class="mask-settings bg-dark grid-mask-img d-inline-block"
					[ngClass]="minimizedFilter ? 'navigate-next-mask-img position-relative' : 'navigate-before-mask-img'"></div>
			</div>
		</div>
		<div class="px-2 ps-xl-4 pe-xl-3 h-100">
			@if (catalog) {
				<div class="d-flex flex-column h-100 scrollContainer">
					<div class="ms-1">
						<!-- Catalog Header -->
						<div
							class="text-dark border search-scroll-gutter border-white text-decoration-none catalogHeaderContainer img-holder-hovereffekt-wrapper">
							<div class="d-flex flex-row px-0 w-100">
								<div class="w-100" [ngClass]="catalogHeaderSelected ? 'catalogheader-selected' : 'bg-gray-200'">
									<a
										[routerLink]="rootLink"
										(click)="onCatalogHeaderClick()"
										queryParamsHandling="merge"
										[queryParams]="{
											tab: null,
											mobileView: null,
										}"
										class="text-dark text-decoration-none cursor-pointer"
										id="catalogheaderId">
										<div class="d-flex justify-content-lg-start">
											<div class="img-holder img-holder-hover bg-white">
												@if (catalog.key) {
													<lib-catalog-logo-img
														[catalogKey]="catalog.key"
														[alt]="catalog?.title"
														height="6.72rem"
														width="9.293rem"
														loading="eager" />
												}
											</div>
											<div id="titleTextHeader" class="d-flex flex-column justify-content-center ps-4 p-2">
												<div>
													<span
														id="titleText"
														[ngbTooltip]="titleToolTip"
														container="body"
														class="fw-bold two-lines text-large"
														>{{ catalog.title }}</span
													>
												</div>
												@if (categoriesText) {
													<div class="text-larger">
														<span
															id="titleCategoryText"
															[ngbTooltip]="categoryTooltip"
															container="body"
															class="one-line"
															>{{ categoriesText }}</span
														>
													</div>
												}
											</div>
										</div>
									</a>
								</div>
								<div class="flex-grow-1">
									@if (catalog.hasContactPersons) {
										<a
											aria-label="Navigate to Contactperson"
											class="d-block ms-1"
											[routerLink]="rootLink"
											[queryParams]="{
												tab: 'CatalogContactPersons',
											}"
											[ngbTooltip]="'catalog-view.catalog-header.contact-person.title' | translate"
											placement="top"
											[container]="'body'">
											<div
												class="bg-dark grid-mask-img contact-persons-mask-img zindex-fixed size-2rem mask-settings contact-persons-icon-hover"></div>
										</a>
									}
								</div>
							</div>
						</div>
					</div>
					@if (hasTree || currentRoutingParams.view !== 'search') {
						<div [ngClass]="currentRoutingParams.view !== 'search' ? 'mt-3 pt-1' : ''" class="flex-grow overflow-hidden h-100">
							@if (currentRoutingParams.view !== 'search') {
								@defer {
									<app-catalog-tree></app-catalog-tree>
								}
							} @else {
								@defer {
									<app-catalog-searchresult></app-catalog-searchresult>
								}
							}
						</div>
					}
				</div>
			}
			@if (!catalog) {
				<div class="d-flex flex-column h-100">
					<div class="d-flex justify-content-center align-items-center h-100 w-100">
						<lib-loading class="w-100"></lib-loading>
					</div>
				</div>
			}
		</div>
	</div>
</div>
